// constants in here will be shared w/
// graphql, and used as the source of truth

export enum OnboardingPageIds {
  PersonalInfoStudent = 'personalInfoStudent',
  PersonalInfoEmployer = 'personalInfoEmployer',
  EmployerInfo = 'employerInfo',
  UnlockAccount = 'unlockAccount',
  PersonalInfoProvider = 'personalInfoProvider',
  SelectNpi = 'selectNpi',
  CurrentJob = 'currentJob',
  Responsibilities = 'responsibilities',
  Compensation = 'compensation',
  Benefits = 'benefits',
  ReviewInfo = 'reviewInfo',
  OptionalInfo = 'optionalInfo',
  LocumPrnWrapUp = 'locumPrnWrapUp',
}

export enum SurveyStatus {
  InProgress = 'inProgress',
  Completed = 'completed',
  SalaryReviewed = 'salaryReviewed',
}

export enum OnboardingAccountType {
  Student = 'student',
  Physician = 'physician',
  Employer = 'employer',
  AdvancedPractice = 'advanced-practice',
}

export const ONBOARDING_PROVIDER_SURVEY_NAME = 'onboardingProvider'
export const ONBOARDING_EMPLOYER_SURVEY_NAME = 'onboardingEmployer'
export const ONBOARDING_STUDENT_SURVEY_NAME = 'onboardingStudent'
export const ONBOARDING_UNKNOWN_ID = 'unknown'
export const onboardingAccountTypeSurveyMap = {
  [OnboardingAccountType.Physician]: ONBOARDING_PROVIDER_SURVEY_NAME,
  [OnboardingAccountType.AdvancedPractice]: ONBOARDING_PROVIDER_SURVEY_NAME,
  [OnboardingAccountType.Student]: ONBOARDING_STUDENT_SURVEY_NAME,
  [OnboardingAccountType.Employer]: ONBOARDING_EMPLOYER_SURVEY_NAME,
}

export const ANALYTICS_ONBOARDING_PROFESSION = {
  [OnboardingAccountType.Physician]: 'Physician',
  [OnboardingAccountType.AdvancedPractice]: 'APP',
  [OnboardingAccountType.Student]: 'Student',
  [OnboardingAccountType.Employer]: 'Employer',
}

export const IS_FROM_ONBOARDING_PARAM_NAME = 'isFromOnboarding'
